import React from 'react';
import { Select } from './Select';
import { CHAIN_CONFIGS } from '../../utils/constants';

interface ChainSelectorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  excludeChains?: string[];
  onlyChains?: string[];
  disabled?: boolean;
  error?: string;
  fullWidth?: boolean;
}

export const ChainSelector: React.FC<ChainSelectorProps> = ({
  value,
  onChange,
  label = 'Select Chain',
  excludeChains = [],
  onlyChains,
  disabled = false,
  error,
  fullWidth = true,
}) => {
  // Filter chains based on excludeChains and onlyChains
  const filteredChains = Object.entries(CHAIN_CONFIGS)
    .filter(([key]) => !excludeChains.includes(key))
    .filter(([key]) => !onlyChains || onlyChains.includes(key))
    .map(([key, config]) => ({
      value: key,
      label: config.name,
      icon: (
        <div className="w-6 h-6 rounded-full overflow-hidden mr-2 flex-shrink-0">
          <img 
            src={config.icon} 
            alt={config.name} 
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback if image fails to load
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )
    }));

  // Add empty option at the beginning
  const options = [
    { value: '', label: 'Select a chain', disabled: true },
    ...filteredChains,
  ];

  return (
    <Select
      label={label}
      options={options}
      value={value}
      onChange={onChange}
      disabled={disabled}
      error={error}
      fullWidth={fullWidth}
      className="pr-10"
    />
  );
};
